// extracted by mini-css-extract-plugin
export var coverVideo = "blog-module--coverVideo--3GzXD";